/*** Pre Define Constant Values For Product Listing Api Call Start ***/
// const shopUrl = "https://"+window.Shopify.shop;
// const collectionHandel = "engagement-rings-melbourne";
/*** Pre Define Constant Values For Product Listing Api Call End ***/

/*** Diamond Price Filter End ***/
function getPriceCalibArray(minDiamondPrice,maxDiamondPrice) {
  var price = [];

  for (var i = parseInt(minDiamondPrice); (i < 500 && i<maxDiamondPrice); i = i+10) {
    price.push(i);
  };
  for (var i = 500; (i < 1000 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 1000; (i < 1500 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 1500; (i < 2000 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 2000; (i < 3000 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 3000; (i < 4000 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 4000; (i < 4500 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  for (var i = 4500; (i < 5000 && i<maxDiamondPrice); i = i+45) {
    price.push(i);
  };
  for (var i = 5000; (i < 50000 && i<maxDiamondPrice); i = i+1) {
    price.push(i);
  };
  
  
  price.push(parseInt(maxDiamondPrice));
  return price;
}

function get_priceindex(price_min,price_max,value) {
    var price = getPriceCalibArray(price_min,price_max);  
  var pos = 0
  for (i = 0; i < price.length; i++) {
    if (price[i] == value) {
      pos = i;
      break;
    }
  }
  return pos;
}
  
function price_slider_render(min_price,max_price,option,filterLabel){
    var price = getPriceCalibArray(default_price_min,default_price_max);
  
    var minPrice = getClosestNum(min_price,price);
    var maxPrice = getClosestNum(max_price,price);  
    var price_min = get_priceindex(default_price_min,default_price_max,minPrice); 
    var price_max = get_priceindex(default_price_min,default_price_max,maxPrice);   

    //session price filter selected
    var isSelected = false;
    if(min_price != default_price_min || max_price != default_price_max){
       isSelected = true;
    }
    var filterValues = filterLabel+': '+Shopify.formatMoney(min_price*100, theme.moneyFormat)+' - '+Shopify.formatMoney(max_price*100, theme.moneyFormat);   
    setSettingSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');
     //end
   
        jQuery("#tps_price_slider").slider({
            range: true,
            min: 0,
            max: price.length-1,
            values: [ price_min,price_max ],
            step:0.1,
            slide: function( event, ui ) { 
                if ((ui.values[0]) > (ui.values[1])) { 
                    return false; 
                }
                jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
    
                var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                price_form = price_form.replace(/([.,]00)$/, '');
                jQuery('#price_from').val(price_form);
                var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                price_to = price_to.replace(/([.,]00)$/, '');
                jQuery('#price_to').val(price_to);

                option = true;
            },
            change: function(event, ui) {
              var resetFlag = checkResetFlag();
              emptyProductResultDiv();         
              if(option == true) {                         
                 jQuery('#price_left_hidden').val(price[parseInt(ui.values[0])]);
                 jQuery('#price_right_hidden').val(price[parseInt(ui.values[1])]);
                
                 var price_form = ""+Shopify.formatMoney(price[parseInt(ui.values[0])]*100, theme.moneyFormat);
                    price_form = price_form.replace(/([.,]00)$/, '');
                 jQuery('#price_from').val(price_form);
                 var price_to = ""+Shopify.formatMoney(price[parseInt(ui.values[1])]*100, theme.moneyFormat);
                     price_to = price_to.replace(/([.,]00)$/, '');
                 jQuery('#price_to').val(price_to);
                  
                 //applied filters 
                 var isSelected = false;
                 
                 if(price[parseInt(ui.values[0])] != default_price_min || price[parseInt(ui.values[1])] != default_price_max){
                    isSelected = true;
                 }           
                
                 var filterValues = filterLabel+': '+price_form+' - '+price_to;          
                 
                 setSettingSelectedFilter(filterValues,"price_slider_render('"+default_price_min+"', '"+default_price_max+"','true','"+filterLabel+"')",isSelected,'price');

                 updateSessionFilters(session_variable+'-filters',filterLabel, price[parseInt(ui.values[0])]+","+price[parseInt(ui.values[1])]);
                 //end                               

                 if(resetFlag != 'true'){
                    jQuery('#page_no').val(1);
                    jQuery('#pagination').val('');
                    ajaxDataCall();
                 }                 
                 return false;
              }else if(option == false) {
                   jQuery('#price_left_hidden').val(min_price);
                   jQuery('#price_right_hidden').val(max_price);
      
                   var price_form = ""+Shopify.formatMoney(min_price*100, theme.moneyFormat);
                   jQuery('#price_from').val(price_form);
                   var price_to = ""+Shopify.formatMoney(max_price*100, theme.moneyFormat);
                   jQuery('#price_to').val(price_to);

                   updateSessionFilters(session_variable+'-filters',filterLabel, min_price+","+max_price);

                   if(resetFlag != 'true'){
                     jQuery('#page_no').val(1);
                     jQuery('#pagination').val(''); 
                     setTimeout(function(){
                       ajaxDataCall();
                     }, 10);
                   }

                   setTimeout(function(){
                     option = true;
                   }, 25); 
                                      
                   return false;
                }
              slide = '';
            }
             
        });
        
      var start_num = parseInt(min_price);
      var end_num = parseInt(max_price);

      var start_dec = start_num.toFixed(0);
      var end_dec = end_num.toFixed(0);

     jQuery('#price_left_hidden').val(start_dec);
     jQuery('#price_right_hidden').val(end_dec);       
     jQuery('#price_from').val(Shopify.formatMoney(start_dec*100, theme.moneyFormat));  
     jQuery('#price_to').val(Shopify.formatMoney(end_dec*100, theme.moneyFormat));
}


/*** Price Validation Start ***/
$("#price_to").keypress(function(e) {
  //if the letter is not digit then display error and don't type anything
  if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
    return false;
  }
});

$("#price_from").keypress(function(e) {
  //if the letter is not digit then display error and don't type anything
  if (e.which != 8 && e.which != 0 && (e.which < 48 || e.which > 57)) {
    return false;
  }
});

// Clear value on focus 
$(document).on('focus', '#price_from, #price_to', function () {
  $(this).val('');
});
// RESTORE value if left empty (delegated)
jQuery(document).on('blur', '#price_from', function () {
  if (jQuery(this).val().trim() === '') {
    var value = jQuery('#price_left_hidden').val();
    jQuery(this).val(
      Shopify.formatMoney(value * 100, theme.moneyFormat).replace(/([.,]00)$/, '')
    );
  }
});

jQuery(document).on('blur', '#price_to', function () {
  if (jQuery(this).val().trim() === '') {
    var value = jQuery('#price_right_hidden').val();
    jQuery(this).val(
      Shopify.formatMoney(value * 100, theme.moneyFormat).replace(/([.,]00)$/, '')
    );
  }
});
/*** Price Validation End ***/

function replace_price_from(ele,priceMin,filterLabel) {   
  if (jQuery('#price_from').val() == '') {
    var value = parseFloat(jQuery('#price_left_hidden').val());          
        var formatted_max_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
    jQuery('#price_from').val(formatted_max_price);
    return false;
  } else {
    var price_min = jQuery('#price_from').val();
  }
  
    var price_min_value = parseInt(getPriceWithoutSymbolAndCommas(price_min));
  var price_max_value = parseInt(jQuery('#price_right_hidden').val());
  
    var default_price_min_value = parseFloat(default_price_min);
    var formatted_min_price = ""+Shopify.formatMoney(default_price_min_value*100, theme.moneyFormat);
  
  if (isNaN(price_min_value) != false) {    
        alert(translations.titlePleaseEnterValueInNumber);  
    jQuery('#price_from').val(formatted_min_price);
        return false;
  } else if (price_min_value < default_price_min) {  
        alert(translations.titleIncorrectPriceRange);   
    jQuery('#price_from').val(formatted_min_price);
    return false;
  } else if (price_min_value > price_max_value) { 
        alert(translations.titleIncorrectPriceRange);        
    price_slider_render(default_price_min, price_max_value, false, filterLabel);
    return false;
  }

  jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
  jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
  price_slider_render(price_min_value, price_max_value, false, filterLabel);

}

function replace_price_to(ele,priceMax,filterLabel) {
  if ($('#price_to').val() == ''){
    var value = parseFloat($('#price_right_hidden').val());
        var formatted_min_price = ""+Shopify.formatMoney(value*100, theme.moneyFormat);
    $('#price_to').val(formatted_min_price);        
    return false;
  } else {
    var price_max = $('#price_to').val();        
  }

    var price_max_value = parseInt(getPriceWithoutSymbolAndCommas(price_max));
    var price_min_value = parseInt(jQuery('#price_left_hidden').val());

    var default_price_max_value = parseFloat(default_price_max);
    var formatted_max_price = ""+Shopify.formatMoney(default_price_max_value*100, theme.moneyFormat);
  
  if (isNaN(price_max_value) != false) {
        alert(translations.titlePleaseEnterValueInNumber);        
    jQuery('#price_to').val(formatted_max_price);
        return false;
  } else if (price_max_value > default_price_max) {         
        alert(translations.titleIncorrectPriceRange);
    jQuery('#price_to').val(formatted_max_price);        
    return false;
  } else if (price_min_value > price_max_value) {       
        alert(translations.titleIncorrectPriceRange);
    jQuery('#price_to').val(formatted_max_price);        
    return false;
  } else if (price_min_value == '') {
    jQuery('#price_from').val(price_min_value);
  }

  jQuery('#price_right_hidden').val(price_max_value.toFixed(0));
  jQuery('#price_left_hidden').val(price_min_value.toFixed(0));
  price_slider_render(price_min_value, price_max_value, false, filterLabel);
}


function getPriceWithoutSymbolAndCommas(input_price) {
  if (!input_price) return 0;

  // Remove everything except digits and decimal point
  var cleaned = input_price
    .toString()
    .replace(/[^0-9.]/g, '');

  return cleaned;
}
/*** Diamond Price Filter End ***/
/*** Setting Carat Filter Start ***/
window.caratState = window.caratState || {
  initialized: false,
  fromSession: false,
  min: null,
  max: null
};
function getCaratFromSession() {

  let session = JSON.parse(localStorage.getItem(session_variable + '-filters')) || {};

  if (!session.Carat || !Array.isArray(session.Carat)) return false;

  let min = parseFloat(session.Carat[0]);
  let max = parseFloat(session.Carat[1]);

  if (isNaN(min) || isNaN(max)) return false;

  window.caratState.fromSession = true;
  window.caratState.min = min;
  window.caratState.max = max;

  return true;
}
$(document).ready(function () {

  if (window.caratState.initialized) return;

  let hasSession = getCaratFromSession();

  let min, max;

  if (hasSession) {
    min = window.caratState.min;
    max = window.caratState.max;
  } else {
    min = default_carat_min;
    max = default_carat_max;
  }

  carat_slider_render(min, max);

  window.caratState.initialized = true;

});
function carat_slider_render(minValue, maxValue, isReset = false) {

  let $slider = $("#carat-slider");

  // ALWAYS USE GLOBAL RANGE (NOT session values)
  let minRange = window.default_carat_min || 0.1;
  let maxRange = window.default_carat_max || 30;

  minValue = parseFloat(minValue);
  maxValue = parseFloat(maxValue);

  // fallback to full range if invalid
  if (isNaN(minValue)) minValue = minRange;
  if (isNaN(maxValue)) maxValue = maxRange;

  if ($slider.hasClass("ui-slider")) {
    $slider.slider("destroy");
  }

  $slider.slider({
    range: true,
    min: minRange,
    max: maxRange,
    step: 0.01,

    // applied values go here
    values: [minValue, maxValue],

    slide: function (event, ui) {
      $('#carat_from').val(ui.values[0]+ ' ct');
      $('#carat_to').val(ui.values[1]+ ' ct');
    },

    stop: function (event, ui) {
      applyCaratFilter(ui.values[0], ui.values[1]);
    }
  });

  // sync UI
  $('#carat_from').val(minValue+ ' ct');
  $('#carat_to').val(maxValue+ ' ct');

  $('#carat_left_hidden').val(minValue);
  $('#carat_right_hidden').val(maxValue);

  $('#setting_carat').val(minValue + ',' + maxValue);

  if (isReset) {
    $('#setting_carat').val('');
  }
}

function replace_carat_from() {

  let minVal = parseFloat($('#carat_from').val());
  let maxVal = parseFloat($('#carat_to').val());

  if (isNaN(minVal)) return;
  if (minVal > maxVal) return;

  $("#carat-slider").slider("values", 0, minVal);

  applyCaratFilter(minVal, maxVal);
}

function replace_carat_to() {

  let minVal = parseFloat($('#carat_from').val());
  let maxVal = parseFloat($('#carat_to').val());

  if (isNaN(maxVal)) return;
  if (minVal > maxVal) return;

  $("#carat-slider").slider("values", 1, maxVal);

  applyCaratFilter(minVal, maxVal);
}
function applyCaratFilter(minVal, maxVal) {

    let sessionKey = session_variable + '-filters';

    // SAFE VALUE (prevents undefined / empty)
    minVal = (minVal !== undefined && minVal !== null && minVal !== '') ? minVal : 0;
    maxVal = (maxVal !== undefined && maxVal !== null && maxVal !== '') ? maxVal : 0;

    let value = minVal + ',' + maxVal;

    $('#setting_carat').val(value);

    // ✅ UPDATE SESSION
    updateSessionFilters(sessionKey, 'Carat', value);

    let filter_value = 'Carat: ' + minVal + ' - ' + maxVal + ' ct';

    setSettingSelectedFilter(
        filter_value,
        "removeCaratFilter()",
        true,
        'carat'
    );

    $('#page_no').val(1);
    emptyProductResultDiv();
}
function removeCaratFilter() {

    let sessionKey = session_variable + '-filters';

    // REMOVE FROM SESSION (CRITICAL FIX)
    removeSessionFilter(sessionKey, 'Carat');

    // reset hidden field
    $('#setting_carat').val('');

    // reset slider safely
    carat_slider_render(default_carat_min, default_carat_max, true);

    // remove UI filter
    setSettingSelectedFilter(
        '',
        '',
        false,
        'carat'
    );
    $('#Carat-container').remove();
    $('#page_no').val(1);

    emptyProductResultDiv();
    ajaxDataCall();
}

function restoreCaratFromSession(sessionKey) {

    let sessionData = JSON.parse(localStorage.getItem(sessionKey)) || {};
    let caratValue = sessionData['Carat'];

    if (!caratValue) return false;

    let min, max;

    // ALWAYS normalize format
    if (Array.isArray(caratValue)) {
        min = parseFloat(caratValue[0]);
        max = parseFloat(caratValue[1]);
    } else if (typeof caratValue === "string") {
        let range = caratValue.split(',');
        min = parseFloat(range[0]);
        max = parseFloat(range[1]);
    } else {
        return false;
    }

    if (isNaN(min) || isNaN(max)) return false;

    // update hidden fields
    $('#carat_left_hidden').val(min);
    $('#carat_right_hidden').val(max);

    // update UI inputs
    $('#carat_from').val(min + ' ct');
    $('#carat_to').val(max + ' ct');

    // update slider AFTER ready
    setTimeout(function () {
        if ($("#carat-slider").hasClass("ui-slider")) {
            $("#carat-slider").slider("values", [min, max]);
        }
    }, 100);

    return true;
}

/*** Setting Carat Filter End ***/
/*** Treatment  Filter Start ***/
function getProductTreatment(product){
  if (!product.tags) return '';

  var treatment = '';

  product.tags.forEach(function(tag){
    if(tag.toLowerCase().includes('filter-treatment:')){
      treatment = tag.split(':')[1].trim();
    }
  });

  return treatment;
}
$(document).on('click', 'input[name="treatment"]', function (e) {

  var $this = $(this);
  var value = $this.val();
  var $parent = $this.closest('.tps-filter-treatment-option');

  // If already active → REMOVE (toggle off)
  if ($parent.hasClass('active')) {

    e.preventDefault(); // stop default re-check

    $this.prop('checked', false);
    $('.tps-filter-treatment-option').removeClass('active');
    $('#setting_treatment').val('');

    var sessionKey = session_variable + '-filters';
    var sessionData = JSON.parse(localStorage.getItem(sessionKey)) || {};
    sessionData['Treatment'] = [];
    localStorage.setItem(sessionKey, JSON.stringify(sessionData));

    // Remove applied filter UI
    setSettingSelectedFilter('Treatment: ' + value, '', false, 'treatment');

  } else {

    // Normal select
    $('input[name="treatment"]').prop('checked', false);
    $this.prop('checked', true);

    $('.tps-filter-treatment-option').removeClass('active');
    $parent.addClass('active');

    $('#setting_treatment').val(value);

    var sessionKey = session_variable + '-filters';
    var sessionData = JSON.parse(localStorage.getItem(sessionKey)) || {};
    sessionData['Treatment'] = value ? [value] : [];
    localStorage.setItem(sessionKey, JSON.stringify(sessionData));

    // Applied filter UI
    var filterTitle = 'Treatment: ' + value;
    var filterFunction = "removeTreatmentFilter('" + value + "')";

    setSettingSelectedFilter(filterTitle, filterFunction, true, 'treatment');
  }

  // Common actions
  $('#page_no').val(1);
  emptyProductResultDiv();
  ajaxDataCall();
});
function removeTreatmentFilter(value){

  $('input[name="treatment"][value="'+value+'"]').prop('checked', false);

  // REMOVE ACTIVE CLASS
  $('.tps-filter-treatment-option').removeClass('active');

  $('#setting_treatment').val('');

  var sessionKey = session_variable + '-filters';
  var sessionData = JSON.parse(localStorage.getItem(sessionKey)) || {};

  sessionData['Treatment'] = [];
  localStorage.setItem(sessionKey, JSON.stringify(sessionData));

  setSettingSelectedFilter('Treatment: ' + value, '', false, 'treatment');

  $('#page_no').val(1);
  emptyProductResultDiv();
  ajaxDataCall();
}
function setSessionSelectedTreatment(session_data){
  if(session_data['Treatment'] && session_data['Treatment'].length > 0){
    var value = session_data['Treatment'][0];

    var $input = $('input[name="treatment"][value="'+value+'"]');

    $input.prop('checked', true);
    $('#setting_treatment').val(value);

    // RESTORE ACTIVE CLASS
    $('.tps-filter-treatment-option').removeClass('active');
    $input.closest('.tps-filter-treatment-option').addClass('active');

    // Applied filter UI
    var filterTitle = 'Treatment: ' + value;
    var filterFunction = "removeTreatmentFilter('" + value + "')";

    setSettingSelectedFilter(filterTitle, filterFunction, true, 'treatment');
  }
}
/*** Treatment  Filter End ***/

/*** Sort Filter Start ***/ 
$(document).on("click", ".tps-sort-option", function() {
  sortByClose();
  emptyProductResultDiv();
  
  var sort_by = $(this).attr('data-sort');
  var sort_title = $(this).attr('data-title');
  var sort_type = $(this).attr('data-type');
  
  jQuery('#sort_by').val(sort_by);

  jQuery('.tps-sort-by-value').html('<span>'+sort_title+'</span>');
  jQuery('.tps-sort-option').removeClass('active');
  jQuery('.tps-sort-'+sort_by).addClass('active');
  
  jQuery('#page_no').val(1);
  
  ajaxDataCall(); 
  
  updateSessionFilters(session_variable+'-other-data','Sort-By',sort_by);
  updateSessionFilters(session_variable+'-other-data','Sort-Title',sort_title);
});
/*** End ***/

/*** Set Session Selected Sort Filter Start ***/
function setSessionSelectedSortValues(sortBy,sortTitle) {  
  jQuery('.tps-sort-option').removeClass('active');
  jQuery('.tps-sort-'+sortBy).addClass('active');  

  jQuery('.tps-sort-by-value').html(sortTitle);
}
/*** Set Session Selected Sort Filter End ***/

/*** CheckBox Type Filter Selection Common Function Start ***/
function setSettingCheckboxtypeFilter(ele,parentClass,valueid,filter){  
     var filter_value = jQuery(ele).find("input").attr('data-value');
     var filterLable = filter.toLowerCase(); 
     emptyProductResultDiv();

     if(jQuery(ele).hasClass('selected')){
        filter_value = '';
        jQuery(ele).removeClass('selected');
        $('#'+valueid).val('');
     }else{     
        jQuery('.tps-filter-'+filterLable+'-li').removeClass('selected');
        jQuery(ele).addClass('selected');
         $('#'+valueid).val(filter_value);
     }  
       
    jQuery('#page_no').val(1);
    ajaxDataCall();
    updateSessionFilters(session_variable+'-filters',filter, filter_value);
  
    //Applied filter code start 
    var filterTitle = filter+': '+filter_value;
    var filterFunction = "remove"+filter+"Filter('"+filter_value+"')"; 
    var hasClass = jQuery(ele).hasClass('selected');
    setSettingSelectedFilter(filterTitle,filterFunction,hasClass,filterLable);
    //end  
}
/*** End ***/

/*** Remove Shape Filter From Applied Filter Start ***/
function removeShapeFilter(shape){ 
  jQuery('.tps-filter-shape-list input[data-value="'+shape+'"]').click();
}
/*** Remove Shape Filter From Applied Filter End ***/

/*** Remove Metal Filter From Applied Filter Start ***/
function removeMetalFilter(metal){ 
  jQuery('.tps-filter-metal-list input[data-value="'+metal+'"]').click();
}
/*** Remove Metal Filter From Applied Filter End ***/

/*** Remove Style Filter From Applied Filter Start ***/
function removeStyleFilter(style){ 
  jQuery('.tps-filter-style-list input[data-value="'+style+'"]').click();
}
/*** Remove Style Filter From Applied Filter End ***/

/*** Set Selected Filters For Session Filters After Reloading Page start ***/
function setSettingSelectedFilter(filter_value, func, hasSelectedClass, input_value = '') {    
  if (input_value == 'price') {
    $('.tps-selected-filter-container').find('li[data-input="price"]').remove();
  }else if (input_value == 'shape') {     
    $('.tps-selected-filter-container').find('li[data-input="shape"]').remove();
  }else if (input_value == 'style') {
    $('.tps-selected-filter-container').find('li[data-input="style"]').remove();
  }else if (input_value == 'metal') {
    $('.tps-selected-filter-container').find('li[data-input="metal"]').remove();
  }else if (input_value == 'treatment') {
    $('.tps-selected-filter-container').find('li[data-input="treatment"]').remove();
  }else if (input_value === 'carat') {
    $('.tps-selected-filter-container').find('li[data-input="carat"]').remove();
  }
  
  var value = filter_value.split(':');
   
  if (hasSelectedClass) {
    var html = '';
        var filter_lable = value[1].trim();
        if(input_value != 'price') {
          //filter_lable = filter_lable.replace(/\-/g, ' ');
        }
    html += '<li onclick="' + func + '" data-input="' + input_value + '" data-filter-value="' + filter_value + '"><div class="tps-filter-values">' + filter_lable + '<span class="tps-filter-remove-option"></span></div></li>';
    if ($('#' + value[0] + '-container').length > 0) {
      $('#' + value[0] + '-container').append(html);
    } else {
      var elecontainer = '<ul id="' + value[0] + '-container"><span class="tps-applied-filter-lable">' + value[0] + ':</span></ul>';
      $('.tps-selected-filter-container').append(elecontainer);
      $('#' + value[0] + '-container').append(html);
    }    
  } else {
    $('.tps-selected-filter-container').find('li[data-filter-value="' + filter_value + '"]').remove();
    if ($('input[value="' + input_value + '"]').length > 0) {
      $('input[value="' + input_value + '"]').prop('checked', false);
    }

    if ($('#' + value[0] + '-container li').length == 0) {
      $('#' + value[0] + '-container').remove();
    }
  }
  if ($('.tps-selected-filter-container li').length > 0) {
    $('.tps-selected-filter-wrapper').show();
  } else {
    $('.tps-selected-filter-wrapper').hide();
  }

    //display applied filter count for mobile view start
    var filterlength = $(".tps-selected-filter-container ul").length;
    if(filterlength > 0){
      $(".tps-total-filter-applied").text('('+filterlength+')');
    } 
    //display applied filter count for mobile view end
}
/*** Set selected filters for session filters after reloading page end ***/
function updateCaratUI(min, max) {

    $("#carat-min-display").text(min);
    $("#carat-max-display").text(max);

    // optional: update label
    $(".carat-display").text(min + " - " + max + " ct");
}
/*** Insert Session Selected Values In Input Fields Start ***/
function getSessionSelectedSettingFilterValues(session_data) {  
  $.each(session_data, function(key,value){ 
    var inputKey = key.toLowerCase();
    
    if(key == 'Shape' || key == 'Metal' || key == 'Style'){    
        if(value != ''){
          var inputValues = value.toString();          
          $('#setting_'+inputKey).val(inputValues);
    
          var filterArrayKey = key;
          var filterArrayValues = value;
    
          setTimeout(function(){ 
            setSessionSelectedSettingCheckBoxFilters(filterArrayKey,filterArrayValues);
          }, 50);  
        }
    }else if(key == 'Price'){
      $('#'+inputKey+'_left_hidden').val(value[0]);
      $('#'+inputKey+'_right_hidden').val(value[1]);
    }else if(key == 'Carat'){

        if(value !== null && value !== undefined && value !== '') {

            let range;

            if (typeof value === "string") {
                range = value.split(',');
            } else if (Array.isArray(value)) {
                range = value;
            } else if (typeof value === "object") {
                range = [value.min, value.max];
            }

            if (range && range.length === 2) {

                let min = parseFloat(range[0]);
                let max = parseFloat(range[1]);

                if (!isNaN(min) && !isNaN(max)) {

                    let caratValue = min + ',' + max;

                    // INPUT RESTORE
                    $('#setting_carat').val(caratValue);

                    let waitSlider = setInterval(function () {

                        if ($("#carat-slider").data("ui-slider")) {

                            // SLIDER RESTORE
                            $("#carat-slider").slider("values", [min, max]);

                            // UI TEXT UPDATE
                            updateCaratUI(min, max);

                            // CRITICAL FIX: REBUILD FILTER UI
                            setSettingSelectedFilter(
                                'Carat: ' + min + ' - ' + max + ' ct',
                                "removeCaratFilter()",
                                true,
                                'carat'
                            );

                            clearInterval(waitSlider);
                        }

                    }, 50);
                }
            }

        } else {

            removeSessionFilter(session_variable + '-filters', 'Carat');
            $('#setting_carat').val('');
        }
    }
     
  });    
    // Treatment session
  setTimeout(function(){
    setSessionSelectedTreatment(session_data);
    }, 100);
}
/*** Insert Session Selected Values In Input Fields End ***/

/*** Set Session Selected Checkbox Type Filters Start ***/
function setSessionSelectedSettingCheckBoxFilters(filterKey,filterValues) {
  $(filterValues).each(function(index, value) {        
      var filterTitle = filterKey.toLowerCase();
      var filterValue = value.toLowerCase();      
      filterValue = filterValue.replace(/\s+/g, '-');
    
      $(".tps-filter-"+filterTitle+"-checkbox-"+filterValue).prop('checked', true);
      $(".tps-filter-"+filterTitle+"-"+filterValue).addClass('selected');
       
      var filterSelectedValues = filterKey+': '+value; 
      setSettingSelectedFilter(filterSelectedValues,"remove"+filterKey+"Filter('"+value+"')",true,filterTitle);
   });  
}
/*** Set Session Selected Checkbox Type Filters End ***/

/*** Get All Setting Products Start ***/ 
function ajaxDataCall(){  
   //getWishlistProducts();
   var session_variable = jQuery("#session_variable").val();
   var session_other_data = JSON.parse(localStorage.getItem(session_variable+'-other-data'));
     
   jQuery(".tps-productlist-result-grid-view-loader").show();
   jQuery("#tps_product_count").html("<span class='tps-product-count-loader'></span> ");
   //var ringSettingUrl = shopUrl+'/collections/'+collectionHandel+'/products.json?limit=250&page=1'; //get ring setting products using shopify api
   var ringSettingUrl = shopUrl+'/collections/'+collectionHandel+'/products.json?sort_by=manual&limit=250&page=1';   
   //console.log("ringSettingUrl",ringSettingUrl);
    // var ringSettingUrl = settingJsonUrl;
   var prodGridView = '';

   var session_flag = 0;
   if(session_other_data != '' && session_other_data != null){
     if(session_other_data['Back-To-Search-Flag'] != null && session_other_data['Back-To-Search-Flag'] != '' && session_other_data['Back-To-Search-Flag'] != undefined){
        if(session_other_data['Product-Id'][0] != undefined){
          var session_flag = 1;
        }
      }
   }

  var productsPerPage = jQuery("#products_per_page").val();
  if(session_flag != 0){
    var recentPageNo = session_other_data['Recent-Product-Page-No'][0];
    jQuery("#page_no").val(recentPageNo);
    var pageNo = recentPageNo;
    var productShow = recentPageNo * productsPerPage;
    var showFrom = 0;
    var showTo = parseInt(productShow) - 1;
  }else{
     var pageNo = jQuery("#page_no").val();
     var productShow = pageNo * productsPerPage;
     var showFrom = productsPerPage * (pageNo - 1);
     var showTo = parseInt(showFrom) + parseInt(productsPerPage) - 1;
   }       

   abortAjax(xhr);
   
    $("#tps-infinite-loader").show(); // Show loader
   var productDataArray = [];
  
   xhr = $.ajax({
     type: 'GET',
     url: ringSettingUrl,
     dataType: 'json',
     success: function (data){   
   //  console.log('data',data);
        var products = data.products;

        //  attach metafield first
        products.forEach(function(product){
        product.treatment = getProductTreatment(product);
        product.carat = getProductCarat(product);
        });

        //  Carat range (ADD HERE)
        var caratRange = getCaratRange(products);

        if (window.default_carat_min === undefined || window.default_carat_max === undefined) {
          window.default_carat_min = caratRange.min;
          window.default_carat_max = caratRange.max;
        }      

       var productsData = productFilters(products); //product filter function  
        console.log('productsData',productsData);
       var productCount = productsData.length;
       
       jQuery("#tps_product_count").html(" "+addCommas(productCount)+" ");
       jQuery("#total_products_count").val(productCount);
       jQuery(".tps-total-products").html(addCommas(productCount));

       if(parseInt(productCount) > 0){
         $('.tps-product-grid-view-container').removeClass('tps-no-product');
         var swatchesData = new Array();

         // setTimeout(function(){
           $.each(productsData, function (i, product) {                
             if(i >= showFrom && i <= showTo){
               prodGridView += getProductGridViewLayout(product,collectionHandel,i);  
             }
           });
         
         // }, 500);

         jQuery('.tps-productlist-result-grid-view-items-list').append(prodGridView);  
       }else{
         //no products found
          jQuery('.tps-productlist-result-grid-view-items-list').html('');
          prodGridView += '<span class="tps-no-product-found">'+translations.titleNoProductFound+'</span>';      
          jQuery('.tps-productlist-result-grid-view-items-list').addClass('tps-no-product-found'); 
          jQuery('.tps-productlist-result-grid-view-items-list').append(prodGridView);  
       }       

      
      if(productCount < productsPerPage || productCount == productsPerPage){
        var previous_page_no = parseInt(pageNo)-1;
        var total_previous_products = previous_page_no*productsPerPage;
        var products_viewed = parseInt(total_previous_products)+parseInt(productCount); 
        if(productCount == 0){
            var products_viewed = productCount;
            jQuery("#tps-infinite-loader").hide(); 
            
        }else{
            var products_viewed = parseInt(total_previous_products)+parseInt(productCount); 
            jQuery("#tps-infinite-loader").show();             
        }                    
        //  jQuery('.tps-total-products-displays').html(addCommas(products_viewed));
      }else{
          jQuery("#tps-infinite-loader").show();
          if(pageNo == 1){    
              var products_viewed = productsPerPage;
          }else{
              var products_viewed = pageNo*parseInt(productsPerPage);
              if(products_viewed > productCount){
                products_viewed = productCount;
                if(products_viewed == productCount){
                  jQuery("#tps-infinite-loader").hide();
                }
              }              
          }    
         // jQuery('.tps-total-products-displays').html(addCommas(products_viewed));          
          jQuery('.tps-load-more-button-section').show();
      }
       
      


       //product info focus return from product detail page          
        if(session_flag != 0){
            var recentProduct = session_other_data['Product-Id'][0];            
            focusRecentProduct(recentProduct);            
        }             
        //end 

       jQuery(".tps-productlist-result-grid-view-loader").hide();
       $("#tps-infinite-loader").hide(); // Hide infinite loader
       var page_id = parseInt(pageNo)+1;  
       jQuery('#page_no').val(page_id);          
      
      // Stop infinite scroll and hide loader if all products loaded
      if(products_viewed >= productCount){
          tps_noMoreProducts = true;
          $("#tps-infinite-loader").hide(); // hide loader permanently
      } else {
          tps_noMoreProducts = false;
          $("#tps-infinite-loader").show(); // show loader for next batch
      }

            tps_isLoading = false;
            //createPaginationLayout(page_id,productCount,productsPerPage);
     },
      error: function () {
      $("#tps-infinite-loader").hide();
      tps_isLoading = false;
    }

   });
}
/*** Get All Setting Products End ***/ 


/*** Pagination Layout Start ***/

// ================================================
// Infinite Scroll Setup
// ================================================
let tps_isLoading = false;        // Prevents multiple triggers
let tps_noMoreProducts = false;   // Stops when no more products
// Dynamic scroll trigger offset based on window height
const tps_scrollTriggerOffset = Math.round($(window).height() * 0.85); // 50% of viewport height
let lastScrollTime = 0;           // Throttle time in ms
const scrollThrottle = 300;       // minimum interval between scroll triggers




$(window).on('scroll', function() {
  const now = Date.now();
  if (now - lastScrollTime < scrollThrottle) return; // throttle
  lastScrollTime = now;

  if (tps_isLoading || tps_noMoreProducts) return;

  const scrollTop = $(window).scrollTop();
  const windowHeight = $(window).height();
  const docHeight = $(document).height();
  const productList = $('.tps-productlist-result-grid-view-items-list');

  if (!productList.length) return;

  const productListTop = productList.offset().top;
  const productListBottom = productListTop + productList.outerHeight();

  // --- Visibility Zones ---
  const viewportBottom = scrollTop + windowHeight;

  //  1. Completely below list (jumped to footer)
  const isCompletelyBelowList = scrollTop > productListBottom + 300;

  //  2. In-between zone (part footer + part listing visible)
  const isBetweenSections =
    viewportBottom > productListTop + 100 && scrollTop < productListBottom - 100;

  //  3. Near bottom of listing (typical infinite scroll trigger)
  const nearBottomOfList = viewportBottom >= productListBottom - 200;

  //  Skip only if user is *way* below product list
  if (isCompletelyBelowList) return;

  //  Trigger in any of these cases:
  // - near bottom of list
  // - in between list & footer (partial view)
  // - near page bottom (in case content height is short)
  if (nearBottomOfList || isBetweenSections || viewportBottom >= docHeight - 150) {
    tps_isLoading = true;
    ajaxDataCall();
  }
});



/*** Focus Recently View Product Start ***/
function focusRecentProduct(product_id) {
  var target = '.product-grid-item-'+product_id;

  if($(target).length) {
    $(target).addClass('tps-recent-viewed-product');
    $('html, body').animate({
          scrollTop: $(target).offset().top - 300
    }, 'slow'); 
  }  
  updateSessionFilters(session_variable+'-other-data','Product-Id', '');
  updateSessionFilters(session_variable+'-other-data','Recent-Product-Page-No', '');
  updateSessionFilters(session_variable+'-other-data','Back-To-Search-Flag', '');
  setTimeout(function(){ $(target).removeClass('tps-recent-viewed-product'); }, 4000);
}
/*** End ***/

/*** Get Product Grid View layout Start ***/ 
function getProductGridViewLayout(product,collectionHandel,diamondIndex){  
  var wishlistProducts = jQuery("#wishlist_products").val();
  wishlistProducts = wishlistProducts.split(",");
  //console.log("product",product);
  var banner_display_count = jQuery('#tps_banner_row_count').val();
  var diamond_index = (diamondIndex % 40)+1;   
 
   //Get Hover Image
  var images = product.images;
   //console.log("images",images);
  const altAndSrc = images.map(image => ({
    alt: image.alt,
    src: image.src
  }));
  
  var pageNo = jQuery("#page_no").val();
  var metalFilter = jQuery("#setting_metal").val();
  var filteredMetal = metalFilter.replace(/^18K\s/, '');
  filteredMetal = metalFilter.replace(/^18ct\s/, '');
  filteredMetal = metalFilter.replace(/^14K\s/, '');
  filteredMetal = metalFilter.replace(/^18ct\s/, '');
  filteredMetal = metalFilter.replace(/^9K\s/, '');
  filteredMetal = metalFilter.replace(/^9ct\s/, '');
 

  // Filter images, ensuring alt exists and starts with the filteredMetal
  const filteredImages = altAndSrc.filter(item => 
    item.alt && typeof item.alt === 'string' && item.alt.startsWith(filteredMetal)
  );
  
  // Get the appropriate src based on the condition
  const singleSrc = filteredImages.length > 0 
    ? (filteredImages[1] ? filteredImages[1].src : filteredImages[0].src) // Use the 1st position image if it exists, otherwise the 0th position
    : altAndSrc[0].src; // Fallback to the 0th position image from the original array
  
  
  
  var produtSwaches = getProductSwatches(product,collectionHandel);  
  //console.log('product',product);
  var productVariant = getProductVariant(product, collectionHandel);
  var productPrice = '';

var price = product?.variants?.[0]?.price;
// let currentPath = window.location.pathname;
// console.log("currentPath",currentPath);

var collectionHandel = '';

if (pathParts[0] === 'collections') {
  collectionHandel = pathParts[1] || '';
}

if (price) {
  productPrice = Shopify.formatMoney(parseFloat(price) * 100, theme.moneyFormat);
  productPrice = productPrice.replace(/([.,]00)$/, '');
}
    
  var productCompareAtPrice = Shopify.formatMoney(productVariant[0].compare_at_price * 100, theme.moneyFormat);
  // var productImage = productVariant[0].image;
  // var productHoverImage = productVariant[0].secondImage; 
  var productDefaultVariant = productVariant[0].metal;
  var stockOption = product?.variants?.[0]?.available;
console.log("Available:"+ stockOption );
 
 
 

  var productImage = product.images?.[0]?.src || '';
  //console.log("productImage",productImage);

// Get hover image only from same metal images
var productHoverImage = product.images?.[1]?.src || productImage;

if(filteredImages.length > 1){
  productHoverImage = filteredImages[1].src;
}
  

  var productGrid = '';
  productGrid += '<li class="tps-productlist-result-grid-view-item product-grid-row product-grid-item-'+product.id+'" data-id="'+product.id+'" data-page="'+pageNo+'">'; 
  productGrid += '<div class="tps-productlist-item-media-div-section tps-productlist-item-media-div-'+product.id+'">';

  /*** product wishlist functionality start ***/
  if(jQuery.inArray(product.id.toString(),wishlistProducts)==(-1)){
    //display add to wishlist button    
    var addToWishlist = 'Xb-add';
    var removeFromWishlist = '';    
  }else{
    //display remove from wishlist button 
    var addToWishlist = '';
    var removeFromWishlist = 'Xb-add';     
  } 
  

  /*** product wishlist functionality end ***/  

  /*** productquick add functionality start ***/  
  productGrid += '<div class="tps-quick-add">';
  productGrid += '<button class="tps-quick-add-btn" data-product-handle="'+product.handle+'" data-product-id="'+product.id+'">';
   productGrid += '+';
  productGrid += '</button>';
  productGrid += '</div>';
  /*** productquick add functionality end ***/   
  
  productGrid += '<a href="/collections/'+collectionHandel+'/products/'+product.handle+'" data-id="'+product.id+'" data-page="1">';
  productGrid += '<div class="tps-productlist-item-media-div sp">';
  if (stockOption === false) {
  productGrid +='<span class="tps-sold-out">Sold Out</span>';
  }
  productGrid += '<img class="tps-productlist-item-img tps-product-first-image" data-placeholder-img="" alt="'+product.title+' '+productDefaultVariant+'" title="'+product.title+' '+productDefaultVariant+'" src="'+productImage+'" loading="lazy" width="300" height="300">';
  productGrid += '<img class="tps-productlist-item-img tps-product-second-image" data-placeholder-img="" alt="'+product.title+' '+productDefaultVariant+'" title="'+product.title+' '+productDefaultVariant+'" src="'+productHoverImage+'" loading="lazy" width="300" height="300">';
  productGrid += '</div>';
  productGrid += '</a>';
  productGrid += '</div>';
  
  productGrid += '<div class="tps-productlist-item-wrapper">';
   productGrid += '<div class="tps-productlist-item-wrapper-block swatch-updated-variant-id-'+product.id+'">';
  productGrid += '<a href="/collections/'+collectionHandel+'/products/'+product.handle+'" data-id="'+product.id+'" data-page="1">';
  productGrid += '<div class="tps-productlist-item-view-title">'+product.title+'</div>';   
  productGrid += '</a>';
  productGrid += '</div>';
  if(produtSwaches != '' && produtSwaches != null){
    productGrid += '<div class="tps-productlist-item-swatches">';
     let activeMetalName = '';

    $.each(produtSwaches, function (i, swatch) {  
      var metalSwatch = swatch.metal;
      metalSwatch = metalSwatch.replace(/^18K\s/, '');
      metalSwatch = metalSwatch.replace(/^14K\s/, '');
      metalSwatch = metalSwatch.replace(/^9K\s/, '');
      metalSwatch = metalSwatch.replace(/^18ct\s/, '');
      metalSwatch = metalSwatch.replace(/^14ct\s/, '');
      metalSwatch = metalSwatch.replace(/^9ct\s/, '');
      var matchingImages = images.filter(image => image.alt === metalSwatch);
      const imageSrcs = matchingImages.map(image => image.src);
      var hoverImageUrl = swatch.secondImage;
     
      productGrid += '<div class="tps-productlist-item-swatch tps-productlist-item-swatch-'+swatch.id+' '+swatch.active+'" title="'+swatch.metal+'" parent-id="'+product.id+'" data-id="'+swatch.id+'">';
      productGrid += '<div data-id="'+swatch.id+'" onclick="changeProductData(`'+product.title+'`,`'+product.id+'`,`'+swatch.id+'`,`'+swatch.metal+'`,`'+swatch.price+'`,`'+swatch.compare_at_price+'`,`'+swatch.image+'`,`'+swatch.url+'`,`'+hoverImageUrl+'`)">';
      productGrid += '<span class="tps-productlist-item-metal-icon metal-'+swatch.class+'">'+swatch.metal+'</span>';
      productGrid += '</div>';
      productGrid += '</div>';

      // Capture active metal
      if (swatch.active === 'active') {
        activeMetalName = swatch.metal;
      }
    });

     productGrid += '<div class="metal-active-title metal-title-'+product.id+'">'+activeMetalName+'</div>';
    productGrid += '</div>';
  }
  
  productGrid += '<div class="tps-productlist-item-view-info tps-productlist-item-view-info-'+product.id+'">';
  productGrid += '<a href="/collections/'+collectionHandel+'/products/'+product.handle+'" data-id="'+product.id+'" data-page="1">';
  productGrid += '<div class="tps-productlist-item-view-price">Price : '+productPrice+'<span class="tps-price-inc-gst">Inc. GST</span></div>';   
  
  productGrid += '</a>';
  productGrid += '</div>';
  productGrid += '</div>';
  productGrid += '</li>';

  //banner start  
  if(jQuery(window).width() > 900 && jQuery(window).width() < 1198){    
    banner_display_count = parseInt(banner_display_count)+1; //for tab view display banner after 21 diamonds
  }
  
   
  if(diamond_index == banner_display_count){
      var bannerHtml = $('#tps_banner_blog_'+pageNo).html();
      if(bannerHtml != '' && bannerHtml != undefined){
        productGrid += '<li class="tps-diamondlist-banner-section">';
        productGrid += '<div class="tps-diamond-listing-page-banner">'+bannerHtml+'</div>';
        productGrid += '</li>';
      }
  }  
  //banner end

  return productGrid;
}
/*** Get Product Grid View layout End ***/

/*** On Swatches Click Change Variant Data Start ***/
function changeProductData(productTitle,productId,variantId,variantTitle,variantPrice,variantCompareAtPrice,variantImage,variantUrl,hoverImg){ 
  jQuery('.product-grid-item-'+productId+' .tps-productlist-item-swatch').removeClass('active');
  jQuery('.tps-productlist-item-swatch-'+variantId).addClass('active');
  jQuery('.tps-productlist-item-media-div-'+productId).addClass('tps-gallery-loading');   
  var productPrice = Shopify.formatMoney(variantPrice * 100, theme.moneyFormat);
  var productCompareAtPrice = Shopify.formatMoney(variantCompareAtPrice * 100, theme.moneyFormat);

  var productMedia = '';
  productMedia += '<a href="'+variantUrl+'" data-id="'+productId+'" data-page="1">';
  productMedia += '<div class="tps-productlist-item-media-div ss">';
  productMedia += '<img class="tps-productlist-item-img tps-product-first-image" data-placeholder-img="" alt="'+productTitle+'" title="'+productTitle+'" src="'+variantImage+'" loading="lazy" width="300" height="300">';
  if (hoverImg !== '' && hoverImg !== null && hoverImg !== undefined){
     productMedia += '<img class="tps-productlist-item-img tps-product-second-image" data-placeholder-img="" alt="'+productTitle+' '+variantTitle+'" title="'+productTitle+' '+variantTitle+'" src="'+variantImage+'" loading="lazy" width="300" height="300">';
  }else{
     productMedia += '<img class="tps-productlist-item-img tps-product-second-image" data-placeholder-img="" alt="'+productTitle+' '+variantTitle+'" title="'+productTitle+' '+variantTitle+'" src="'+variantImage+'" loading="lazy" width="300" height="300">';
  } 
  productMedia += '</div>';
  productMedia += '</a>';  
  jQuery('.tps-productlist-item-media-div-'+productId).html(productMedia);  

  var productinfo = '';
  productinfo += '<a href="'+variantUrl+'" data-id="'+productId+'" data-page="1">';
  //productinfo += '<div class="tps-productlist-item-view-title">'+productTitle+'</div>';  
  productinfo += '<div class="tps-productlist-item-view-price">'+productPrice+'</div>'; 
  //productinfo += '<div class="tps-productlist-item-view-price">'+productPrice+' <span class="tps-price-info">'+translations.titleSettingOnly+'</span></div>'; 
  //productinfo += '<div class="tps-productlist-item-view-price">';  
  // if(productCompareAtPrice != '' || productCompareAtPrice != null){    
  //   productinfo += '<span class="tps-compare-price-info">'+productCompareAtPrice+'</span>';
  //   productinfo += '<span class="tps-price-separator"> / </span>';
  // }
  //productinfo += '<span class="tps-sales-price-info">'+productPrice+'</span>';
  //productinfo += '<span class="tps-price-info"> '+translations.titleSettingOnly+'</span>';
  //productinfo += '</div>'; 
  productinfo += '</a>';

  var producttitleinfo = '';
  producttitleinfo += '<a href="'+variantUrl+'" data-id="'+productId+'" data-page="1">';
  producttitleinfo += '<div class="tps-productlist-item-view-title">'+productTitle+'</div>';   
  producttitleinfo += '</a>';

  jQuery('.swatch-updated-variant-id-'+productId).html(producttitleinfo);  
    jQuery('.metal-title-'+productId).html(variantTitle);  
  jQuery('.tps-productlist-item-view-info-'+productId).html(productinfo);  
  jQuery('.tps-productlist-item-media-div-'+productId).removeClass('tps-gallery-loading');   
}
/*** On Swatches Click Change Variant Data End ***/

/*** Get variant Data After Filter Apply Start ***/
function getProductVariant(product, collectionHandel){

  var variantData = [];
  var shapeFilter = jQuery("#setting_shape").val();  
  var metalFilter = jQuery("#setting_metal").val(); 

  var productVariants = product.variants || [];
  var productHandle = product.handle;   
  var productMedia = product.images;

  var i = 0;

  // ✅ Check if real options exist
  var hasRealOptions = product.options && product.options.length > 1;

  /* ===============================
     🔥 SIMPLE PRODUCTS (YOUR CASE)
  =============================== */
  if (!hasRealOptions) {

    var variant = productVariants[0];

    if (variant) {
      variantData = [getProductSelectedOption(variant, productHandle, productMedia, collectionHandel)];
    }

    return variantData;
  }

  /* ===============================
     🔁 VARIANT-BASED PRODUCTS
  =============================== */
  productVariants.forEach(function(variant){

    var variantShape = variant.option2;
    var variantMetal = variant.option1;

    if(shapeFilter == '' && metalFilter == ''){
      if(i == 0){
        variantData = [getProductSelectedOption(variant,productHandle,productMedia,collectionHandel)];
        i++;
      }
    }
    else if(shapeFilter && metalFilter){
      if(shapeFilter == variantShape && metalFilter == variantMetal){
        variantData = [getProductSelectedOption(variant,productHandle,productMedia,collectionHandel)];
      }
    }
    else if(!shapeFilter && metalFilter){
      if(metalFilter == variantMetal && i == 0){
        variantData = [getProductSelectedOption(variant,productHandle,productMedia,collectionHandel)];
        i++;
      }
    }
    else if(shapeFilter && !metalFilter){
      if(shapeFilter == variantShape && i == 0){
        variantData = [getProductSelectedOption(variant,productHandle,productMedia,collectionHandel)];
        i++;
      }
    }
    else{
      variantData = [getProductSelectedOption(variant,productHandle,productMedia,collectionHandel)];
    }

  });

  return variantData;
}

function getProductSelectedOption(variant,productHandle,productMedia,collectionHandel){
   var variantInfo = new Array();
   var variantShape = variant.option2;
   var variantMetal = variant.option1;
   var varientImage = placeholderImageUrl.ring_placeholder;
   var varientSecondImage = placeholderImageUrl.ring_placeholder;
   var varientFeaturedImage  = variant.featured_image;
   var varientalt  = "data";
  
        
   if(varientFeaturedImage != null){
     varientImage = getImageByID(productMedia,variant.featured_image.id);
     varientSecondImage = getSecondImageByID(productMedia,variant.featured_image.id);
   } 
 
   var productUrl = '/collections/'+collectionHandel+'/products/'+productHandle+'?variant='+variant.id+'&sku='+variant.sku;
  
   variantInfo.push({
      id: variant.id,
      sku: variant.sku,
      shape: variantShape,
      metal: variantMetal,
      url: productUrl,
      alt: varientalt,
      image: varientImage,
      secondImage: varientSecondImage,
      price: variant.price,
      compare_at_price: variant.compare_at_price,
   });
  
  return variantInfo;
}
/*** Get variant Data After Filter Apply End ***/

/*** Get Product Swatches Data Start ***/
function getProductSwatches(product,collectionHandel){
   var swatchesData = new Array();
   var productVariants = product.variants;
   var productImages = product.images;
   var shapeFilter = jQuery("#setting_shape").val(); 
   var metalFilter = jQuery("#setting_metal").val();
   var diaQualityFilter = jQuery("#setting_diamond_quality").val(); 
   var productOptions = product.options;
 //console.log("productOptions",productOptions);
   var productMetalArray = productOptions?.[0]?.values || [];
var productShapeArray = productOptions?.[1]?.values || [];
var productDiaQualityArray = productOptions?.[2]?.values || [];

var productDefaultShape = productShapeArray[0] || '';
var productDefaultMetal = productMetalArray[0] || '';
var productDefaultDiaQuality = productDiaQualityArray[0] || '';
   var i = 0;
 // console.log("productVariants",productVariants);
   if(productVariants != ''){
     $(productVariants).each(function(index, option){  
         var variantMetal = option.option1;  
         var variantShape = option.option2;
         var variantdiaQuality = option.option3;
         var metalClass = variantMetal.toLowerCase();
         metalClass = metalClass.replace(/\s+/g,"-");         

         var active = '';
         if(metalFilter == variantMetal){
           var active = 'active'; 
         }else if(metalFilter == '' && productDefaultMetal == variantMetal && productDefaultShape == variantShape && productDefaultDiaQuality == variantdiaQuality ){
           var active = 'active'; 
         }
       
         if(shapeFilter != '' && variantShape == shapeFilter && diaQualityFilter != '' && variantdiaQuality == diaQualityFilter){                       
             var productUrl = '/collections/'+collectionHandel+'/products/'+product.handle+'?variant='+option.id+'&sku='+option.sku;
             var imageUrl = placeholderImageUrl.ring_placeholder;
             var varientSecondImage = placeholderImageUrl.ring_placeholder;            
             if(option.featured_image != null && option.featured_image != undefined){                
               imageUrl = getImageByID(productImages,option.featured_image.id);
               varientSecondImage = getSecondImageByID(productImages,option.featured_image.id);
             }
                      
             swatchesData.push({
                id: option.id,
                sku: option.sku,
                metal: variantMetal,
                shape: variantShape,
                diamond_quality: variantdiaQuality,
                class: metalClass,
                url: productUrl,
                active: active,
                image: imageUrl,
                price: option.price,
                compare_at_price : option.compare_at_price,
                secondImage: varientSecondImage,
             });
         }else if(shapeFilter == ''){                 
             var productUrl = '/collections/'+collectionHandel+'/products/'+product.handle+'?variant='+option.id+'&sku='+option.sku;  
             var imageUrl = placeholderImageUrl.ring_placeholder;
             var varientSecondImage = placeholderImageUrl.ring_placeholder; 
             
             if(option.featured_image != null && option.featured_image != undefined){           
               imageUrl = getImageByID(productImages,option.featured_image.id);
               varientSecondImage = getSecondImageByID(productImages,option.featured_image.id);
             }             
           
             // if(index <= 3){
               if(productDefaultShape == variantShape && productDefaultDiaQuality == variantdiaQuality){
                 swatchesData.push({
                      id: option.id,
                      sku: option.sku,
                      metal: variantMetal,
                      shape: variantShape,
                      diamond_quality: variantdiaQuality,
                      class: metalClass,
                      url: productUrl,
                      active: active,
                      image: imageUrl,
                      price: option.price,
                      compare_at_price : option.compare_at_price,
                      secondImage: varientSecondImage,
                   });
               }
                 
           
             // }
         }
           
     });
   }  
   return swatchesData;
}
/*** Get Product Swatches Data End ***/

/*** Get Image URL By Its ID Start ***/
function getImageByID(productImages,imageId) {
  // var imageUrl = placeholderImageUrl.ring_placeholder;
  // var varientSecondImage = placeholderImageUrl.ring_placeholder;
  // console.log(imageId);
  var imageUrlArray = new Array();
  $(productImages).each(function(index, image){   
    if(image.id == imageId){
      var imageUrl = image.src;
      imageUrlArray.push(imageUrl);
    }
  });
  // console.log("image url "+imageUrlArray[0]);
  return imageUrlArray[0];
}
/*** Get Image URL By Its ID End ***/

/*** Get Image URL By Its ID Start ***/
function getSecondImageByID(productImages,imageId) {
  var imageUrlArray = new Array();
  var imageIndex = new Array();
  $(productImages).each(function(index, image){   
    if(image.id == imageId){      
      var image_index = index+1;
      imageIndex.push(image_index);
    }

    if(imageIndex[0] == index){
      var imageUrl = image.src;
      imageUrlArray.push(imageUrl);
    }
  });

  return imageUrlArray[0];
}
/*** Get Image URL By Its ID End ***/
  
/*** Abort XHR Start ***/
function abortAjax(xhr) {
  if(xhr && xhr.readystate != 4){
    xhr.abort();
  }
}
/*** End ***/ 

/*** Onclick Product Store Product ID & PAge No in Session Start ***/
jQuery(document).on("click", ".tps-productlist-result-grid-view-item", function(e) {
  var container = $(".tps-productlist-item-swatches");
  
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0){     
    var data_page_no = $(this).attr("data-page");
    var data_product_id = $(this).attr("data-id");
    
    updateSessionFilters(session_variable+'-other-data','Recent-Product-Page-No', data_page_no);
    updateSessionFilters(session_variable+'-other-data','Product-Id', data_product_id);
    updateSessionFilters(session_variable+'-other-data','Back-To-Search-Flag', 'true');
  }
});
/*** Onclick Product Store Product ID & PAge No in Session End ***/
/*** Mouse Hover update metal title Start***/
jQuery(document).on('mouseenter mouseleave', '.tps-productlist-item-swatch', function (e) {

  var $this = jQuery(this);
  var $wrapper = $this.closest('.tps-productlist-item-swatches');
  var $titleBox = $wrapper.find('.metal-active-title');

  var textToShow;

  if (e.type === 'mouseenter') {
    // On Hover → show hovered swatch title
    textToShow = $this.attr('title');
  } else {
    // On Leave → revert to active swatch
    textToShow = $wrapper
      .find('.tps-productlist-item-swatch.active')
      .attr('title');
  }

  if (textToShow) {
    $titleBox.text(textToShow);
  }

});
/*** Mouse Hover update metal title End***/

/*** Empty Diamond Result Div On Filter Click Start ***/
function emptyProductResultDiv(){   
  jQuery('.tps-productlist-result-grid-view-items-list').removeClass('tps-no-product-found');
  jQuery('.tps-productlist-result-grid-view-items-list').html('');
  var resetFlag = checkResetFlag();
  if(resetFlag != 'true'){
     tps_isLoading = true;  
    ajaxDataCall();
  } 
}
/*** End ***/

/*** Reset Filters Start ***/
function resetFilters(){
  var session_variable = jQuery("#session_variable").val();
  localStorage.removeItem(session_variable+'-filters');   
  localStorage.setItem('resetFlag', 'true');
  jQuery(".tps-reset-filter-confirm-popup-div").hide();
  
  if(typeof(Storage) !== "undefined"){
    $('.tps-selected-filter-wrapper').hide();
    $('.tps-selected-filter-container ul').remove();
    
    $('.tps-filter-shape-li').removeClass('selected');
    $(".tps-filter-shape-checkbox").prop('checked', false);
    $('#setting_shape').val('');

    $('.tps-filter-metal-li').removeClass('selected');
    $(".tps-filter-metal-checkbox").prop('checked', false);
    $('#setting_metal').val('');

    $('.tps-filter-style-li').removeClass('selected');
    $(".tps-filter-style-checkbox").prop('checked', false);
    $('#setting_style').val('');

    // Treatment Reset Start
    $('.tps-filter-treatment-option').removeClass('active');
    $('input[name="treatment"]').prop('checked', false);
    $('#setting_treatment').val('');
    // Treatment Reset End

    // 💎 CARAT RESET
    $('#setting_carat').val('');

    window.caratSliderInitialized = false;

    carat_slider_render(default_carat_min, default_carat_max, true);

    window.caratSliderInitialized = true;

    // remove applied filter UI
    $('.tps-selected-filter-container') .find('li[data-input="carat"]').remove();

    price_slider_render(default_price_min, default_price_max, true, translations.titlePrice);     

    $('.tps-sort-option').removeClass('active');
    $('.tps-sort-price-ascending').addClass('active');
    jQuery('.tps-sort-by-value').html('<span>'+translations.titlePriceSortLowToHigh+'</span>');
    jQuery('#sort_by').val('price-ascending');     

    updateSessionFilters(session_variable+'-other-data','Sort-By', 'price-ascending');
    updateSessionFilters(session_variable+'-other-data','Sort-Title', translations.titlePriceSortLowToHigh);
    $(".tps-total-filter-applied").text('');
    
    jQuery('#page_no').val(1);
    ajaxDataCall();

    setTimeout(function(){
      localStorage.setItem('resetFlag','false');
    }, 1000);
  }
}
/*** End ***/

/*** Check Reset Flag Start ***/
function checkResetFlag() {
  var resetFlag = localStorage.getItem('resetFlag');
  return resetFlag;
}
/*** Check Reset Flag End ***/

/*** Reset Filter Popoup Close Outer Click Start ***/
jQuery(document).on('click','#MainContent',function(e){
  var container = $(".tps-tab2");
    
  // If the target of the click isn't the container
  if(!container.is(e.target) && container.has(e.target).length === 0){     
    jQuery(".tps-reset-filter-confirm-popup-div").hide();
  }
});
/*** Reset Filter Popoup Close Outer Click End ***/
  /**** Tooltip Information Open/Close Start ****/ 
function infoPopup(ringField,action){  
  if(action == 'open'){
    $(".tps-ring-field-"+ringField).addClass('tps-popup-info-show');    
  }else{
    $(".tps-ring-field-"+ringField).removeClass('tps-popup-info-show');    
  }  
}
/**** Tooltip Information Open/Close End ****/ 